
require("./../../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import SEO from 'global/SEO';
import { siteUrl } from 'constants/app';
import dynamic from 'next/dynamic';

const Chartbit = dynamic(() => import('features/pro-tools/Chartbit'));
const HomePageLayout = dynamic(() => import('global/HomePageLayout'));

function ChartbitPage() {
  return (
    <HomePageLayout whiteFooterBackground>
      <SEO
        title="Stockbit - Chartbit Tools"
        description="Charting tools modern dan canggih dengan ratusan indikator untuk menganalisa dan memprediksi harga saham. Kamu bisa menggunakan beberapa indikator, seperti real-time price, 15 tahun price history, deteksi dan pelajari gerak bandar, corporate action event, dan beberapa indikator lainnya."
        url={`${siteUrl}/info/pro-tools/chartbit`}
      />
      <Chartbit />
    </HomePageLayout>
  );
}

export default ChartbitPage;
